// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmployeeRequestsTab_wrapper__3wGDp","wrapper__button":"EmployeeRequestsTab_wrapper__button__1xwyn","title":"EmployeeRequestsTab_title__1MYIl"};